import React, { useEffect, useState } from 'react';
import SolidBlock from '../..//assets/solidBlock.png';
import PaverBlock from '../..//assets/paver-blocks.jpeg';
import KerbStones from '../..//assets/ks.jpg';
import PrecastCompoundWalls from '../..//assets/pcw.jpg';
import Cement from '../..//assets/Cement.jpg';
import TMTSteel from '../..//assets/steel.jpg';
import P_Sand from '../..//assets/p-sand.png';
import M_Sand from '../..//assets/m-sand.jpg';
import Jally from '../..//assets/jally.jpg';
import Dust from '../..//assets/dust.jpg';
import { useTheme } from '../../contexts/ThemeContext';
import { FaBuilding, FaHammer, FaIndustry, FaCheckCircle } from 'react-icons/fa';

import './Products.css';

function Products() {
  const { theme } = useTheme();
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    setIsVisible(true);
  }, []);
  
  const manufacturingProducts = [
    {
      id: 1,
      name: 'Solid Blocks',
      image: SolidBlock,
      description: 'Engineered for strength using premium materials. Exceptional load-bearing, excellent insulation, and soundproofing.',
      features: ['High Strength', 'Thermal Insulation', 'Sound Proof', 'Eco-friendly']
    },
    {
      id: 2,
      name: 'Paver Blocks',
      image: PaverBlock,
      description: 'Durable and aesthetically pleasing paver blocks for walkways, driveways, and outdoor spaces.',
      features: ['Weather Resistant', 'Non-slip Surface', 'Easy Installation', 'Low Maintenance']
    },
    {
      id: 3,
      name: 'Kerb Stones',
      image: KerbStones,
      description: 'High-quality kerb stones for road construction and landscaping projects.',
      features: ['Durable', 'Precise Dimensions', 'Weather Resistant', 'Long Lasting']
    },
    {
      id: 4,
      name: 'Precast Compound Walls',
      image: PrecastCompoundWalls,
      description: 'Ready-to-install precast compound walls for residential and commercial properties.',
      features: ['Quick Installation', 'Cost Effective', 'Customizable', 'Strong & Secure']
    }
  ];
  
  const constructionMaterials = [
    {
      id: 5,
      name: 'Cement',
      image: Cement,
      description: 'Premium quality cement for all construction needs with superior binding properties.',
      features: ['High Grade', 'Fast Setting', 'Consistent Quality', 'Reliable']
    },
    {
      id: 6,
      name: 'TMT Steel',
      image: TMTSteel,
      description: 'Thermo-mechanically treated steel bars with excellent strength and flexibility.',
      features: ['Corrosion Resistant', 'High Tensile Strength', 'Earthquake Resistant', 'Bendable']
    },
    {
      id: 7,
      name: 'M Sand',
      image: M_Sand,
      description: 'Manufactured sand with consistent quality and proper gradation for construction.',
      features: ['Consistent Quality', 'Proper Gradation', 'Eco-friendly', 'Cost Effective']
    },
    {
      id: 8,
      name: 'P Sand',
      image: P_Sand,
      description: 'Plastering sand with fine particles perfect for smooth finishing work.',
      features: ['Fine Particles', 'Smooth Finish', 'Clean & Washed', 'High Quality']
    },
    {
      id: 9,
      name: 'Jally (Aggregates)',
      image: Jally,
      description: 'High-quality aggregates for concrete mixing and construction work.',
      features: ['Uniform Size', 'High Strength', 'Clean & Graded', 'Durable']
    },
    {
      id: 10,
      name: 'Stone Dust',
      image: Dust,
      description: 'Fine stone dust for various construction applications and base preparation.',
      features: ['Fine Grade', 'Compactable', 'Versatile Use', 'Quality Assured']
    }
  ];
  
  return (
    <div className='modern-products-container'>
      {/* Hero Section */}
      <section className='products-hero-section'>
        <div className='hero-background'></div>
        <div className='hero-overlay'></div>
        <div className='container hero-content'>
          <div className={`hero-text text-center ${isVisible ? 'animate-in' : ''}`}>
            <h1 className='hero-title'>
              <span className='text-gradient'>Premium Quality</span>
              <br />Manufacturing Materials
            </h1>
            <p className='hero-description'>
              Discover our comprehensive range of construction and manufacturing materials
            </p>
          </div>
        </div>
      </section>
      
      {/* Manufacturing Materials Section */}
      <section className='products-section'>
        <div className='container'>
          <div className='section-header text-center mb-5'>
            <h2 className='section-title'>
              <FaIndustry className='section-icon' />
              <span className='text-gradient'>Manufacturing</span> Materials
            </h2>
            <p className='section-description'>
              Premium quality manufactured products for modern construction needs
            </p>
          </div>
          <div className='products-grid'>
            {manufacturingProducts.map((product, index) => (
              <div key={product.id} className='product-card' data-aos='fade-up' data-aos-delay={index * 100}>
                <div className='product-image'>
                  <img src={product.image} alt={product.name} className='img-fluid' />
                  <div className='product-overlay'>
                    <FaBuilding className='overlay-icon' />
                  </div>
                </div>
                <div className='product-content'>
                  <h3 className='product-title'>{product.name}</h3>
                  <p className='product-description'>{product.description}</p>
                  <div className='product-features'>
                    {product.features.map((feature, idx) => (
                      <span key={idx} className='feature-tag'>
                        <FaCheckCircle className='feature-icon' />
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      {/* Construction Materials Section */}
      <section className='products-section construction-section'>
        <div className='container'>
          <div className='section-header text-center mb-5'>
            <h2 className='section-title'>
              <FaHammer className='section-icon' />
              <span className='text-gradient'>Construction</span> Materials
            </h2>
            <p className='section-description'>
              Essential construction materials for strong and durable structures
            </p>
          </div>
          <div className='products-grid'>
            {constructionMaterials.map((product, index) => (
              <div key={product.id} className='product-card' data-aos='fade-up' data-aos-delay={index * 100}>
                <div className='product-image'>
                  <img src={product.image} alt={product.name} className='img-fluid' />
                  <div className='product-overlay'>
                    <FaHammer className='overlay-icon' />
                  </div>
                </div>
                <div className='product-content'>
                  <h3 className='product-title'>{product.name}</h3>
                  <p className='product-description'>{product.description}</p>
                  <div className='product-features'>
                    {product.features.map((feature, idx) => (
                      <span key={idx} className='feature-tag'>
                        <FaCheckCircle className='feature-icon' />
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Products;
